import {
	REQUIRED_ONE_OF_CHANNELS,
	REQUIRED_ONE_OF_ROWS
} from "constants/communicationPreferences";
import { z } from "zod";

const CHANNEL_DISPLAY_NAMES: Record<string, string> = {
	email: "email",
	sms: "text messages",
	portal: "portal"
};

export const communicationChannelSchema = z.object({
	notificationTypeId: z.number().catch(0),
	portal: z.boolean().catch(false),
	email: z.boolean().catch(false),
	sms: z.boolean().catch(false)
});

export const communicationPreferencesRecordSchema = z
	.record(z.string(), communicationChannelSchema)
	.superRefine((prefs, ctx) => {
		for (const [systemName, channels] of Object.entries(prefs)) {
			const required = REQUIRED_ONE_OF_CHANNELS[systemName];
			if (!required) {
				continue;
			}
			const hasOne = required.some((ch) => channels[ch as keyof typeof channels] === true);
			if (!hasOne) {
				const labels = required.map((ch) => CHANNEL_DISPLAY_NAMES[ch] ?? ch);
				ctx.addIssue({
					code: "custom",
					message: `At least one of ${labels.join(" or ")} must be selected`,
					path: [systemName]
				});
			}
		}

		for (const rule of REQUIRED_ONE_OF_ROWS) {
			// Only enforce for types actually on screen — both screens render whatever the API
			// returned, which may not include every type in the group.
			const present = rule.systemNames.filter((systemName) => systemName in prefs);
			if (!present.length) {
				continue;
			}

			if (present.some((systemName) => prefs[systemName][rule.channel] === true)) {
				continue;
			}

			// Flag every type in the group so the message shows against whichever row the user is on.
			for (const systemName of present) {
				ctx.addIssue({ code: "custom", message: rule.message, path: [systemName] });
			}
		}
	});
